import UpdatePaymentNumber from "@/views/public/try_out/UpdatePaymentNumber";

export default {
  path: "/try-out/update-payment-number",
  name: "UpdatePaymentNumber",
  component: UpdatePaymentNumber
};
